module.exports = __webpack_public_path__ + "img/logo.8971b332.png";